import { useEffect } from 'react';
import { useAuth } from '@/store/authStore';
import { useNotificationActions } from '@/store/notificationStore';

/**
 * 通知轮询 Hook
 * 在已认证状态下自动轮询未读通知数量
 */
export function useNotificationPolling() {
  const { isAuthenticated } = useAuth();
  const { startPolling, stopPolling } = useNotificationActions();

  useEffect(() => {
    if (isAuthenticated) {
      startPolling();
    } else {
      stopPolling();
    }

    return () => {
      stopPolling();
    };
  }, [isAuthenticated, startPolling, stopPolling]);
}
